import { clearInterval } from 'timers';

import cx from 'classnames';
import { RefObject, useEffect, useState } from 'react';

import styles from './switch.module.css';

type TSwitch = {
  label?:
    | string
    | {
        on: string;
        off: string;
      };
  isActive?: boolean;
  onClick?: (isActive: boolean) => void;
};

const Switch = (
  {
    label,
    isActive = false,
    onClick,
    ref
  }: TSwitch
) => {
  const [innerIsActive, setInnerIsActive] = useState(isActive);

  return (
    <button
      {...(ref ? { ref } : {})}
      type="button"
      className={cx(styles.switch, {
        [styles['switch--active']]: innerIsActive,
      })}
      onClick={() => {
        setInnerIsActive(!innerIsActive);
        onClick && onClick(!innerIsActive);
      }}
      aria-label="switch button for shipping prices"
    >
      {!!label
        ? typeof label === 'string'
          ? label
          : label[innerIsActive ? 'on' : 'off']
        : false}
      <span
        className={cx(styles.button, {
          [styles['button--active']]: innerIsActive,
        })}
      ></span>
    </button>
  );
};

Switch.displayName = 'Switch';

export default Switch;
